import { z } from 'zod';
export const JobUserInfoSchema = z.object({
    isNew: z.boolean(),
    isSeen: z.boolean(),
    isSaved: z.boolean(),
    appliedAt: z.date().nullable()
});
//# sourceMappingURL=jobUserInfoSchema.js.map